import React from 'react';
import { Button } from 'grab-ui';
import I18n from 'i18n-js';
import PropTypes from 'prop-types';

import css from './shopify-msd-cta.less';

const ShopifyMsdCta = ({ savingsAmount, onGroupOrder }) => (
  <div className={css.shopifyMsdCta}>
    <div>
      {I18n.t('shopify.orders.createBookingPage.msdCta', {
        amount: savingsAmount,
      })}
    </div>
    <Button onClick={onGroupOrder} type="link">
      {I18n.t('shopify.orders.createBookingPage.msdCtaButton')}
    </Button>
  </div>
);

ShopifyMsdCta.propTypes = {
  onGroupOrder: PropTypes.func,
  savingsAmount: PropTypes.string,
};

ShopifyMsdCta.defaultProps = {
  onGroupOrder: () => {},
  savingsAmount: '',
};

export default ShopifyMsdCta;
